export const userRegistrationComplete = {
    title: 'User Registration',
    heading: 'Registration Complete',
    description: 'An invitation email has been sent.',
    backToLogin: 'Back to Login Page'
}
